import { LoggedInUser } from '../../../../types/LoggedInUser';
import { BlockTextAreaGray } from '../../../Block/BlockTextAreaGray';
import { ButtonBase } from '../../../Button/ButtonBase';
import { InputText } from '../../../Form/InputText';
import { TextArea } from '../../../Form/TextArea';
import { InnerButtonArea } from '../../../Layout/InnerLayout/InnerButtonArea';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';

import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type CancelMembershipApplyContentsProps = {
  loggedInUser: LoggedInUser;
  disableSubmitButton?: boolean;
  eventHandlers?: {
    changeReason: ChangeEventHandler<HTMLTextAreaElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
  reason?: string;
};

export const CancelMembershipApplyContents: FC<
  CancelMembershipApplyContentsProps
> = ({ loggedInUser, disableSubmitButton, eventHandlers, reason }) => (
  <form method="post" onSubmit={eventHandlers?.submit}>
    <TableBody>
      <TableTrFormLabel
        id="email"
        required={true}
        title="登録しているメールアドレス"
      >
        <InputText
          name="email"
          id="email"
          type="email"
          width="default"
          defaultValue={loggedInUser.email}
          disable={true}
        />
      </TableTrFormLabel>
      <TableTrFormLabel id="reason" required={false} title="退会理由">
        <TextArea
          id="reason"
          width="wide"
          placeholder="今後ナース専科を改善していくために、よろしければご記入ください"
          onChange={eventHandlers?.changeReason}
          defaultValue={reason}
        />
      </TableTrFormLabel>
    </TableBody>
    <BlockTextAreaGray title="退会に関する注意事項">
      <span>
        ※掲示板への投稿内容は削除されず、ニックネームが非表示になった状態になります。
      </span>
      <span>※一度退会した会員登録を元に戻すことは出来ません。</span>
      <span>
        ※ナース専科
        看護師賠償責任保険に加入していた場合は契約の自動更新が停止され、契約終了日を以って契約満了となります。
      </span>
    </BlockTextAreaGray>

    <InnerButtonArea>
      <InnerMargin align="center">
        <ButtonBase
          disable={disableSubmitButton === true}
          color="primary"
          width="extend"
        >
          確認画面へ
        </ButtonBase>
      </InnerMargin>
    </InnerButtonArea>
  </form>
);
